import React from 'react';
import { Col, Row, Icon } from 'antd';

import './index.css';

const Card = ({ children, showIcons, creative_id }) => (
  <div className="card" data-id={creative_id}>
    <Row className="grayRow">
      <Col span={24}>
        {children}
        {showIcons && (
          <div className="list-drag-selected moveIcons">
            <Icon type="double-left" className="moveIcon" />
            <Icon type="double-right" className="moveIcon" />
          </div>
        )}
      </Col>
    </Row>
  </div>
);

Card.defaultProps = {
  showIcons: true,
};

export default Card;
